export default {"src":"/_next/static/media/empty-mylist-light.09a18c9d.svg","height":100,"width":100};